import { render, staticRenderFns } from "./08_purpose.vue?vue&type=template&id=4b046c54"
import script from "./08_purpose.vue?vue&type=script&lang=js"
export * from "./08_purpose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports